import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { map } from "rxjs/operators";
import { environment } from '../../../environments/environment';
import { OrderDetalleResponse } from '../../modal/order-detalle/orderDetalleResponse';
import { OrderImageResponse } from '../../modal/order-detalle/order-image-response';




@Injectable({
  providedIn: 'root'
})
export class OrderDetalleService {

  constructor(private httpClient:HttpClient) { }

  obtenerOrderDetalle(idorden:string){
    let url = `${environment.urlBase}${environment.orderDetalleAdmin}/${idorden}`;
    return this.httpClient.get<OrderDetalleResponse>(url).pipe(
      map(data => {   
        let response: OrderDetalleResponse;
        response = data;
        return response;
      },
      error =>{      
        return new Response("9999", error);
      })) 
  }

  obtenerImgDescarga(idImg){
    let url = `${environment.urlBase}${environment.orderImage}/${idImg}`;
    // Cambio: ahora recibimos un Blob (archivo binario) en lugar de JSON
    // observe: 'response' nos da acceso al HttpResponse completo (headers, status, body)
    return this.httpClient.get(url, {
      responseType: 'blob' as 'json', // Truco de TypeScript para evitar errores de tipo
      observe: 'response'
    });
  }



  obtenerOrderDetallePedido(idorden:string){
    let url = `${environment.urlBase}${environment.orderPedido}/${idorden}`;    
    return this.httpClient.get<OrderDetalleResponse>(url).pipe(
      map(data => {   
        let response: OrderDetalleResponse;
        response = data;
        return response;
      },
      error =>{      
        return new Response("9999", error);
      })) 
  }
}
